import { Component, OnInit } from '@angular/core';
import { ColumnMode } from "@swimlane/ngx-datatable";
import { AccountService } from '../../../../shared/services/admServices/accounts.service';
import { Page } from '../../../../shared/filters/filters';
import { Router } from '@angular/router';

@Component({
  selector: 'adm-publishers-component',
  templateUrl: './pub-component.html',
  styleUrls: ['./pub-component.scss']
})

export class accpublishersComponent implements OnInit{
  publishersData: any;
  page = new Page();
  pageSizeDefinition: number = 10;

  ColumnMode = ColumnMode;

  constructor(private router: Router, private accountService: AccountService) {
    this.page.pageNumber = 1;
    this.page.size = this.pageSizeDefinition;
   }

   ngOnInit(): void {
    this.setPage({ offset: 0 });
   }

   setPage(pageInfo){
    this.page.pageNumber = pageInfo.offset+1;
    this.page.size = this.pageSizeDefinition;

    this.accountService.getAllAccount(this.page)
    .subscribe(
     data => {
      this.page.totalElements = data.totalRecords;
      this.page.totalPages = data.totalPages;
      this.page.pageNumber = data.pageNumber-1;

      this.publishersData = data.data.publishers;
     },
     error => {
       console.log(error);
     });
  }

  onNew(){
    this.router.navigate(['/adm/publishers/new']);
  }

}
